module.exports = __webpack_public_path__ + "static/media/TAMOIL.230a7210.svg";